module.exports = __webpack_public_path__ + "img/long-arrow-left.b125f288.svg";